import { Box, Flex, Typography } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React, { Suspense } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import WithCollection from "areas/collection/hoc/with-collection"
import { retry } from "helpers/application"
import { Route } from "helpers/sentry"
import useWindowDimensions from "helpers/window-dimensions"
import Perks from "jewlr/components/perks"

import Media from "../media"

import CarmillaVideo from "./carmilla-video"
import CollectionMain from "./collection-main"
import CustomizeSteps from "./customize-steps"
import FilterHeader from "./filter-header"
import Heading from "./heading/index"
import Loading from "./loading"

const Pagination = loadable(
  () => retry(() => import("areas/collection/pagination")),
  { ssr: false }
)
const CollectionDescription = loadable(
  () => retry(() => import("./collection-description")),
  { ssr: false }
)
const Slider = loadable(() => retry(() => import("./slider")), { ssr: false })
const FilterMobile = loadable(() => retry(() => import("./filter-mobile")), {
  ssr: false,
})
const FilterTags = loadable(() => retry(() => import("./filter-tags")), {
  ssr: false,
})

const MainSection = styled(Box)`
  opacity: ${(props) => (props.showLoading ? "0.2" : "1")};
`

const InternalCollectionBody = ({
  afterFiltersBanners,
  data,
  mainBanners,
  showLoading,
}) => {
  const { isMobile } = useWindowDimensions()

  return (
    <>
      {mainBanners ? (
        <Media firstElement lazyload={false} medias={mainBanners} />
      ) : (
        <Heading data={data} />
      )}

      <Route exact path="/:collection">
        <div id="collection-scroll-back-point">
          <FilterHeader />
          {typeof window !== "undefined" && (
            <Suspense fallback={<div />}>
              <Box contain>
                <FilterTags />
              </Box>
            </Suspense>
          )}
          <CustomizeSteps />

          {afterFiltersBanners && (
            <Media firstElement={false} lazyload medias={afterFiltersBanners} />
          )}

          {false && (
            <Flex
              alignItems="center"
              bg="grey.4"
              flex="1"
              justifyContent="center"
              mb={2}
              py="10px"
            >
              <Box
                as="img"
                mr={1}
                src={require("images/icons/quick_ship_green.svg")}
                width={{ _: "24px", tablet: "30px" }}
              />
              <Typography
                color="black"
                fontSize={{ _: "14px", tablet: "16px" }}
              >
                Indicates items{" "}
                <Box as="span" display={{ _: "none", tablet: "inline" }}>
                  that are
                </Box>{" "}
                ready to ship in 24 to 48 hours
              </Typography>
            </Flex>
          )}
          <Box contain pt={2}>
            {typeof window !== "undefined" && (
              <Suspense fallback={<div />}>
                {isMobile && <FilterMobile />}
              </Suspense>
            )}

            <Loading />

            <MainSection
              minHeight={showLoading ? "250px" : ""}
              showLoading={showLoading}
            >
              <CollectionMain data={data} />
            </MainSection>

            {typeof window !== "undefined" && (
              <Suspense fallback={<div />}>
                <Flex display="none" justifyContent="center">
                  <Pagination compact />
                </Flex>
                <Slider />
                <Perks />
              </Suspense>
            )}

            <CarmillaVideo />
          </Box>
          {typeof window !== "undefined" && (
            <Suspense fallback={<div />}>
              <CollectionDescription />
            </Suspense>
          )}
        </div>
      </Route>
    </>
  )
}

const mapStateToProps = (state) => ({
  afterFiltersBanners: state.collection.banners?.filter(
    (b) => b.location === "after_filters"
  ),
  mainBanners: state.collection.banners?.filter((b) => b.location === "main"),
})

const mapDispatchToProps = () => {
  return {}
}

InternalCollectionBody.propTypes = {
  afterFiltersBanners: PropTypes.array,
  data: PropTypes.object,
  mainBanners: PropTypes.array,
  page: PropTypes.number,
  showLoading: PropTypes.oneOf(["content", "full"]),
}

const CollectionBody = connect(
  mapStateToProps,
  mapDispatchToProps
)(WithCollection(InternalCollectionBody))

export default CollectionBody
